<main>
  <div class="fluid-container index_wrapper">
    <div class="row reg_bg">
      <div class="col-lg-2 col-md-2 hidden-xs"></div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 index_left">
        <img src="/assets/images/ots_logo.png"><span>
           Welcome! This portal offers secure access to your account with the NBCUniversal Owned Television Stations. We’re making it easy for you to view invoices, make secure payments and communicate directly with our finance team.
 </span>
      </div>
     
      <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12" style="text-align: left;">
        <strong class="titleV1">External User Login</strong>
        <div class="input-field minWidth">
          <input name="Address1" [(ngModel)]="email" type="text" class="validate" required [pattern]="emailPattern" placeholder="User ID">
        
        </div>
        <div class="input-field minWidth">         
          
         <div *ngIf="!showPassword"> 
        <input name="Password"   type="password"
               [(ngModel)]="password" placeholder="Password" (keyup)="callLoginByEnter($event)">              
        <span *ngIf="password"
               (click)="toggleShowPassword()"
              class="glyphicon glyphicon-eye-open form-control-feedback eye_modify" 
              style="cursor: pointer; pointer-events: all;">
        </span>
            
      </div>
      
       <!-- show password as type="text"  -->
     <div *ngIf="showPassword"
           > 
        <input type="text"  name="Address2"
               [(ngModel)]="password"  >
        <span *ngIf="password"
              (click)="toggleShowPassword()"
              class="glyphicon glyphicon-eye-close form-control-feedback eye_modify" 
              style="cursor: pointer; pointer-events: all;">
        </span>
      </div>  

        </div>

<div [hidden]="!showErrorMsg" class="input-ErrorField">{{errorMessage}}</div>
        <div class="index_forgotpass" style="cursor:pointer"><a (click)="forgotPassword()">Forgot Password?</a></div>      
           <!-- <button type="button" id="enterlogin"  (click)="loginsubmit($Login)" class="index_submit waves-effect waves-light btn">Submit</button> -->
           <!-- FIx for '$Login' does not exist on type 'ExternalloginComponent' -->
           
           <button type="button" id="enterlogin" (click)="loginsubmit()" class="index_submit waves-effect waves-light btn">Submit</button>

 </div>   
     
    </div>
  </div>
</main>